module.exports = __webpack_public_path__ + "img/00006.6dfeb769.webp";